/**
 * Weekend Pricing Dialog Component
 * Handles weekend price override settings
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Sun } from 'lucide-react';

export default function WeekendPricingDialog({
  open,
  onOpenChange,
  selectedPricingRule,
  formData,
  setFormData,
  onSubmit
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-white">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sun className="h-5 w-5 text-purple-500" />
            Weekend Pricing
          </DialogTitle>
          <DialogDescription>
            Set special pricing for weekends (Saturday & Sunday) on "{selectedPricingRule?.name}"
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="flex items-center gap-2">
            <Switch 
              checked={formData.weekend_enabled} 
              onCheckedChange={(checked) => setFormData({...formData, weekend_enabled: checked})} 
            />
            <Label>Enable Weekend Pricing</Label>
          </div>
          
          {formData.weekend_enabled && (
            <div className="space-y-2">
              <Label>Weekend Price (per night)</Label>
              <Input 
                type="number" 
                value={formData.weekend_price} 
                onChange={(e) => setFormData({...formData, weekend_price: e.target.value})} 
                className="border-orange-200" 
                placeholder="0"
                required={formData.weekend_enabled}
              />
              <p className="text-xs text-gray-500">
                This price will apply on Saturdays and Sundays instead of the base price.
              </p>
            </div>
          )}
          
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" className="bg-gradient-orange text-white">Save Weekend Pricing</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
